// src/utils/downloadStudy.ts
export const downloadStudy = async () => {
  try {
    // Create and display the loader overlay
    const loaderContainer = document.createElement('div');
    loaderContainer.id = 'loader-overlay';
    loaderContainer.style.position = 'fixed';
    loaderContainer.style.top = '10px';
    loaderContainer.style.right = '10px';
    loaderContainer.style.width = '300px';
    loaderContainer.style.padding = '15px';
    loaderContainer.style.backgroundColor = 'rgba(228, 27, 71, 1)';
    loaderContainer.style.color = '#fff';
    loaderContainer.style.borderRadius = '8px';
    loaderContainer.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
    loaderContainer.style.zIndex = '9999';
    loaderContainer.style.fontSize = '1rem';
    loaderContainer.style.textAlign = 'center';

    const loaderText = document.createElement('div');
    loaderText.innerText = 'Iniciando descarga...\nPor favor, espere.';
    loaderContainer.appendChild(loaderText);

    const loader = document.createElement('div');
    loader.className = 'loader';
    loader.style.margin = '10px auto';
    loaderContainer.appendChild(loader);

    document.body.appendChild(loaderContainer);

    const style = document.createElement('style');
    style.innerHTML = `
      .loader {
        width: 120px;
        height: 22px;
        border-radius: 40px;
        color: #424242;
        border: 2px solid;
        position: relative;
        overflow: hidden;
      }
      .loader::before {
        content: "";
        position: absolute;
        margin: 2px;
        width: 14px;
        top: 0;
        bottom: 0;
        left: -20px;
        border-radius: inherit;
        background: currentColor;
        box-shadow: -10px 0 12px 3px currentColor;
        clip-path: polygon(0 5%, 100% 0, 100% 100%, 0 95%, -30px 50%);
        animation: l14 1s infinite linear;
      }
      @keyframes l14 {
        100% { left: calc(100% + 20px); }
      }
    `;
    document.head.appendChild(style);

    const urlParams = new URLSearchParams(window.location.search);
    const studyInstanceUID = urlParams.get('StudyInstanceUIDs');

    if (!studyInstanceUID) {
      console.log('No se pudo determinar el StudyInstanceUID.');
      loaderText.innerText = 'No se pudo obtener el identificador del estudio. Verifica la URL.';
      setTimeout(() => loaderContainer.remove(), 3000);
      return;
    }

    console.log('StudyInstanceUID:', studyInstanceUID);

    // Get the current domain from the URL
    const domain = window.location.hostname;

    // Construct the dcm4chee study download URL
    // Format: https://[domain]/dcm4chee-arc/aets/PACSCLO/rs/studies/[StudyInstanceUID]?accept=application/zip;transfer-syntax=*
    const downloadUrl = `https://${domain}/dcm4chee-arc/aets/PACSCLO/rs/studies/${studyInstanceUID}?accept=application/zip;transfer-syntax=*`;

    console.log('Download URL:', downloadUrl);

    // Create a temporary link to trigger the download
    const link = document.createElement('a');
    link.href = downloadUrl;
    // Suggest a filename for the zip
    link.download = `${studyInstanceUID}.zip`;
    document.body.appendChild(link);
    link.click();

    // Cleanup the link
    document.body.removeChild(link);

    loaderText.innerText = 'Descarga iniciada. \nEl archivo se está descargando.';

    // Remove loader after a short delay since download has started
    setTimeout(() => {
      if (document.body.contains(loaderContainer)) {
        loaderContainer.remove();
      }
    }, 3000);

  } catch (error) {
    console.error('Error durante la descarga:', error);
    const loaderContainer = document.getElementById('loader-overlay');
    if (loaderContainer) {
      const loaderText = loaderContainer.querySelector('div');
      if (loaderText) {
        loaderText.innerText = 'Ocurrió un error inesperado. Por favor, inténtalo más tarde.';
      }
      setTimeout(() => loaderContainer.remove(), 4000);
    }
  }
};
